import React from "react";
import { ChevronRight, Pencil } from "react-bootstrap-icons";
import { ReferralParticipant, ReferralProgram } from "../types";
import * as Styled from "./ReferralProgramCard.styled";

interface Props {
  program: ReferralProgram;
  participants: ReferralParticipant[];
  onEdit: () => void;
  onViewParticipants: () => void;
}

export const ReferralProgramCard: React.FC<Props> = ({
  program,
  participants,
  onEdit,
  onViewParticipants,
}) => {
  const registrations = participants.reduce(
    (total, row) => total + (row.registrationsCount || 0),
    0
  );
  const purchases = participants.reduce((total, row) => total + (row.purchasesCount || 0), 0);
  const enabled = program.status === "ACTIVE";

  return (
    <Styled.Card onClick={onViewParticipants}>
      <Styled.LeftSection>
        <Styled.TitleRow>
          <Styled.Title>{program.name}</Styled.Title>
          <Styled.Badge $active={enabled}>{enabled ? "Active" : "Stopped"}</Styled.Badge>
          <Styled.Badge>
            {program.visibility === "HIDDEN" ? "Invitation only" : "Public"}
          </Styled.Badge>
        </Styled.TitleRow>
        <Styled.Subtitle>{program.description}</Styled.Subtitle>
      </Styled.LeftSection>
      <Styled.Metrics>
        <Styled.Metric>
          <Styled.MetricValue>{participants.length}</Styled.MetricValue>
          <Styled.MetricLabel>Referrers</Styled.MetricLabel>
        </Styled.Metric>
        <Styled.Metric>
          <Styled.MetricValue>{registrations}</Styled.MetricValue>
          <Styled.MetricLabel>Registrations</Styled.MetricLabel>
        </Styled.Metric>
        <Styled.Metric>
          <Styled.MetricValue>{purchases}</Styled.MetricValue>
          <Styled.MetricLabel>Purchases</Styled.MetricLabel>
        </Styled.Metric>
      </Styled.Metrics>
      <Styled.RightSection data-no-propagate onClick={(event) => event.stopPropagation()}>
        <Styled.ActionIcon onClick={onEdit} title="Edit referral program">
          <Pencil />
        </Styled.ActionIcon>
        <Styled.Circle onClick={onViewParticipants} title="View referrers">
          <ChevronRight />
        </Styled.Circle>
      </Styled.RightSection>
    </Styled.Card>
  );
};
